import {useReducer} from 'react';

export function useForceUpdate(): ForceUpdate {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  return forceUpdate;
}

export type ForceUpdate = () => void;
